export const {
  REACT_APP_API_VERSION,
  REACT_APP_API_BASE_URL,
  REACT_APP_GOOGLE_CAPTCHA_SITE_KEY
} = process.env;
export const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}${REACT_APP_API_VERSION}`;
